import { render, staticRenderFns } from "./DeleteVehicleDialog.vue?vue&type=template&id=c2bdaa08&"
import script from "./DeleteVehicleDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteVehicleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports